import type { Theme } from '@mui/material';
import type { SyncStatusTone } from '../model';

/** Dot color per retrieval tone, resolved against the theme at the UI edge. */
export const SYNC_TONE_COLORS: Record<
    SyncStatusTone,
    (theme: Theme) => string
> = {
    pending: (theme) => theme.palette.text.disabled,
    downloading: (theme) => theme.palette.info.main,
    downloaded: (theme) => theme.palette.success.main,
    error: (theme) => theme.palette.error.main,
};
